module.exports = __webpack_public_path__ + "img/whiteBellflower.0f6579ab.jpg";